export const defaultCurrency = 'usd';
export const defaultLocale = 'en-US';
